import { render } from "./Footer.vue?vue&type=template&id=39df5a0e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=39df5a0e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39df5a0e"]])

export default __exports__